import { Component, input } from '@angular/core';
import { Dimension2d, OverlayRectComponent, WordRect } from '@ps-gui/claims-terminal-shared';

@Component({
  selector: 'ct-extraction-table-creation-overlay',
  imports: [OverlayRectComponent],
  template: `
    @let lasso = currentLasso();
    @if (lasso) {
      <ct-shared-overlay-rect
        styleClasses="bg-[#78D8ED26] border-2 border-theme-blue"
        [dimension]="dimension()"
        [rect]="lasso" />
    }
  `,
})
export class TableCreationOverlayComponent {
  readonly currentLasso = input<WordRect>();
  readonly dimension = input.required<Dimension2d>();
}
